<div autocomplete="off">
  <h1 mat-dialog-title>{{ "SearchClient" | localize }}</h1>
  <mat-dialog-content style="width: 900px">
    <div class="row">
        <div class="col-2">
          <app-select-company [(selection)]="selectedCompanyId" (selectionChange)="reListData()" ></app-select-company>
        </div>
        <div class="col-3">
          <mat-form-field>
            <input matInput [placeholder]="'Code' | localize" [(ngModel)]="searchCode" (keydown.enter)="reListData()" />
          </mat-form-field>
        </div>
        <div class="col-3">
          <mat-form-field>
            <input matInput [placeholder]="'TradeName' | localize" [(ngModel)]="searchName"
              (keydown.enter)="reListData()" />
          </mat-form-field>
        </div>
      </div>
    <div class="row">
      <div class="col-12">
        <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
          <ng-container *ngIf="companyVisible" matColumnDef="companyCode">
            <mat-header-cell *matHeaderCellDef>{{
              "Company" | localize
              }}</mat-header-cell>
            <mat-cell *matCellDef="let entity">{{
              entity.company.code
              }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="code">
            <mat-header-cell *matHeaderCellDef>{{
              "Code" | localize
              }}</mat-header-cell>
            <mat-cell *matCellDef="let entity">{{ entity.code }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef>{{
              "TradeName" | localize
              }}</mat-header-cell>
            <mat-cell *matCellDef="let entity">{{ entity.name }}</mat-cell>
          </ng-container>
          <ng-container matColumnDef="actions">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let entity">
              <button mat-button (click)="onSelect(entity)">
                <mat-icon>launch</mat-icon>
              </button>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
        <mat-paginator [length]="totalRows" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
          showFirstLastButtons></mat-paginator>
      </div>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close(false)">
      {{ "Close" | localize }}
    </button>
  </div>
</div>